import { createFileRoute } from '@tanstack/react-router'

import PagePocRecipePreview from '@/pages/PagePocRecipePreview'

export const Route = createFileRoute('/poc/recipe-generator/$runId/preview')({
  component: PagePocRecipePreview
})
